/**
 * intro Block Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initIntroBlock() {
    const blocks = document.querySelectorAll(".intro-block");

    blocks.forEach((block) => {
      // Initialize image crossfade animations
      initImageCrossfade(block);
    });
  }

  /**
   * Initialize GSAP crossfade animation for image galleries
   */
  function initImageCrossfade(block) {
    // Wait for GSAP to be available (may load async)
    let retryCount = 0;
    const maxRetries = 50; // 5 seconds max wait

    function checkGSAP() {
      retryCount++;

      // Check multiple ways GSAP might be available
      let gsapLib = null;

      if (typeof gsap !== "undefined") {
        gsapLib = gsap;
      } else if (typeof window.gsap !== "undefined") {
        gsapLib = window.gsap;
      } else if (
        window.SOJ_GSAP_ANIMATIONS &&
        window.SOJ_GSAP_ANIMATIONS.gsap
      ) {
        gsapLib = window.SOJ_GSAP_ANIMATIONS.gsap;
      }

      if (!gsapLib) {
        if (retryCount < maxRetries) {
          // Retry after a short delay if GSAP isn't loaded yet
          setTimeout(checkGSAP, 100);
          return;
        } else {
          return;
        }
      }

      // Find image containers
      const image1Container = block.querySelector(".image1");
      const image2Container = block.querySelector(".image2");

      // Animate image1 if it has multiple images
      if (image1Container) {
        // Target picture elements specifically (not img inside picture)
        const images1 = Array.from(image1Container.querySelectorAll("picture"));
        if (images1.length > 1) {
          createCrossfadeAnimation(images1, 3, gsapLib); // 3 second duration per image
        } else if (images1.length === 1) {
          // Single image - make sure it's visible
          gsapLib.set(images1[0], { opacity: 1 });
        }
      }

      // Animate image2 if it has multiple images
      if (image2Container) {
        // Target picture elements specifically (not img inside picture)
        const images2 = Array.from(image2Container.querySelectorAll("picture"));
        if (images2.length > 1) {
          createCrossfadeAnimation(images2, 3, gsapLib); // 3 second duration per image
        } else if (images2.length === 1) {
          // Single image - make sure it's visible
          gsapLib.set(images2[0], { opacity: 1 });
        }
      }
    }

    checkGSAP();
  }

  /**
   * Create GSAP crossfade animation timeline
   */
  function createCrossfadeAnimation(images, duration = 3, gsapLib) {
    if (images.length < 2) return;
    if (!gsapLib) {
      return;
    }

    // Set initial state - first image visible, others hidden
    gsapLib.set(images, { opacity: 0 });
    gsapLib.set(images[0], { opacity: 1 });

    // Create timeline that loops infinitely
    const tl = gsapLib.timeline({ repeat: -1, paused: false });

    // Create the animation sequence
    // For each image, fade it out and fade in the next one
    images.forEach((image, index) => {
      const nextIndex = (index + 1) % images.length;
      const nextImage = images[nextIndex];

      // Calculate timing - each transition starts after the previous image's display time
      // Start time is: index * duration (e.g., 0, 3, 6, 9...)
      const startTime = index * duration;

      // Fade out current image and fade in next simultaneously
      tl.to(
        image,
        {
          opacity: 0,
          duration: 1.5,
          ease: "power2.inOut",
        },
        startTime
      ).to(
        nextImage,
        {
          opacity: 1,
          duration: 1.5,
          ease: "power2.inOut",
        },
        startTime
      );
    });

    return tl;
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initIntroBlock);
  } else {
    initIntroBlock();
  }
})();
